/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-01-03 20:22:17
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-03 15:48:50
 */
import { Col, Tabs } from "antd";

import React, { ReactElement } from "react";
import { } from "antd";
import { TabBar } from "../../compnents/widgets/TabBar";
import styles from "./personalManagement.module.css";
import { useSelector } from "react-redux";
import { selectTwoMenus } from "../../layouts/layoutSlice";
import { PersonalSettingsTabs } from "./personalSettingsTabs";
import { NavBar } from "../../compnents/nav/NavBar";
import { useQuery } from "../../utils/HttpUtils";

const { TabPane } = Tabs;
export const PersonalManagement = (): ReactElement => {

  const query = useQuery()

  const id = query.get('id') as string

  const twoMenus = useSelector(selectTwoMenus)

  const menuList = twoMenus?.filter((v) => {
    return v?.name == '个人管理'
  })?.[0]

  const getKeys = (i: string) => {
    switch (i) {
      case '个人详情':
        return '0'
      case '个人设置':
        return '1'
      default:
        return '-'
    }
  }
  return (
    <>
      <Col className={styles.container}>
        {id ? (
          <>
            <Col
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <NavBar
                where={['员工管理', '设置']}
                backtrace={{
                  name: '机构管理',
                  path: '/tenant/manager',
                  state: {
                    station: '0',
                  },
                }}
              /></Col>
            <div style={{ height: 'calc(100% - 40px)', overflow: 'hidden' }}>
              <PersonalSettingsTabs />
            </div>
          </>
        ) : (
          <TabBar>
            <TabPane key={'1'} tab={'个人设置'}>
              <PersonalSettingsTabs />
            </TabPane>
            {/* {menuList?.subMenus?.map((v) => {
              return (
                <>
                  <TabPane key={getKeys(v?.name)} tab={v?.name}>
                    {v?.name == '个人设置' ? (
                      <PersonalSettingsTabs />
                    ) : (
                      <></>
                    )}
                  </TabPane>
                </>
              )
            })} */}
          </TabBar>
        )}
      </Col>
    </>
  )
};
